import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BuyWithConfidenceRevamp from "./component";

const mapStateToProps = ({
    preApprovalLoan: {
        preApproved,
        quotesAvailable
    },
    checkout: {
        stEligibleData
    },
    abExperiment: {
        desktopCarCard
    }
}) => ({
    preApproved,
    quotesAvailable,
    stEligibleData,
    desktopCarCard
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BuyWithConfidenceRevamp);
